export default __webpack_public_path__ + "static/media/101_bananice.5f9c9840.webp";